/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WearableDataSelectionDto
 */
export interface WearableDataSelectionDto {
    /**
     * Start date for wearable data (ISO 8601 format)
     * @type {string}
     * @memberof WearableDataSelectionDto
     */
    startDate?: string;
    /**
     * End date for wearable data (ISO 8601 format)
     * @type {string}
     * @memberof WearableDataSelectionDto
     */
    endDate?: string;
}

/**
 * Check if a given object implements the WearableDataSelectionDto interface.
 */
export function instanceOfWearableDataSelectionDto(value: object): value is WearableDataSelectionDto {
    return true;
}

export function WearableDataSelectionDtoFromJSON(json: any): WearableDataSelectionDto {
    return WearableDataSelectionDtoFromJSONTyped(json, false);
}

export function WearableDataSelectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WearableDataSelectionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
    };
}

export function WearableDataSelectionDtoToJSON(json: any): WearableDataSelectionDto {
    return WearableDataSelectionDtoToJSONTyped(json, false);
}

export function WearableDataSelectionDtoToJSONTyped(value?: WearableDataSelectionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startDate': value['startDate'],
        'endDate': value['endDate'],
    };
}

